export default "__VITE_ASSET__D1l3Iuzv__"